const preparationTime = [
    `<strong>Total:</strong> Approximately 10 minutes`,
    `<strong>Preparation:</strong> 5 minutes`,
    `<strong>Cooking:</strong> 5 minutes`
]

const ingredients = [
    '2-3 large eggs',
    'Salt, to taste',
    'Pepper, to taste',
    '1 tablespoon of butter or oil',
    'Optional fillings: cheese, diced vegetables, cooked meats, herbs'
]

const nutrition = [
    {
        nutrient: 'Calories',
        value: '277kcal'
    },
    {
        nutrient: 'Carbs',
        value: '0g'
    },
    {
        nutrient: 'Protein',
        value: '20g'
    },
    {
        nutrient: 'Fat',
        value: '22g'
    }
]


export {
    preparationTime,
    nutrition,
    ingredients
}